import { render, staticRenderFns } from "./LottieEcommerce.vue?vue&type=template&id=be7c2a86&"
import script from "./LottieEcommerce.vue?vue&type=script&lang=js&"
export * from "./LottieEcommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports